<template>
  <v-autocomplete
    id="municipio-select"
    v-model="filter.municipio"
    item-text="nome"
    item-name="municipioId"
    :items="municipios"
    :label="
      isParceiro
        ? 'Parceiros'
        : isSala
        ? 'Salas'
        : isGov
        ? 'Projetos'
        : 'Municípios'
    "
    :placeholder="
      isParceiro
        ? 'Parceiros'
        : isSala
        ? 'Salas'
        : isGov
        ? 'Projetos'
        : 'Municípios'
    "
    @change="$emit('changeCity', filter.municipio)"
    :multiple="isMultiple"
    :return-object="true"
    :disabled="disabled"
    clearable
    :outlined="outlined"
    :dense="dense"
    :hide-details="'auto'"
    :readonly="readOnly"
  >
    <div
      style="display: flex; padding: 0 16px; cursor: pointer"
      slot="prepend-item"
      ripple
      @click="toggle"
      v-if="isMultiple"
    >
      <div style="margin-right: 32px">
        <v-icon :color="filter.municipio.length > 0 ? 'indigo darken-4' : ''">{{
          icon
        }}</v-icon>
      </div>
      <div>Todos</div>
    </div>
    <v-divider slot="prepend-item" class="mt-2" />

    <template v-slot:selection="{ item, index }">
      <v-chip v-bind="item" small v-if="index < maxDisplay">
        <span>{{ item.nome }}</span>
      </v-chip>
      <span v-if="index === maxDisplay" class="grey--text caption"
        >(+{{ filter.municipio.length - maxDisplay }}
        {{
          isParceiro
            ? "Parceiros"
            : isSala
            ? "Salas"
            : isGov
            ? "Projetos"
            : "Municípios"
        }})</span
      >
    </template>

    <template slot="no-data">
      Nenhum
      {{
        isParceiro
          ? "Parceiros"
          : isSala
          ? "Salas"
          : isGov
          ? "Projetos"
          : "Municípios"
      }}
      retornado
    </template>
  </v-autocomplete>
</template>

<script>
import { cityAPI } from "@/modules/city";
import { readonly } from "vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "AppCityComboboxMultiple",
  props: {
    filter: {
      type: Object,
      required: false,
    },
    isMultiple: {
      type: Boolean,
      default: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    status: {
      type: Array,
      default: () => [],
    },
    outlined: {
      type: Boolean,
      default: false,
    },
    dense: {
      type: Boolean,
      default: false,
    },
    hideDetails: {
      type: [Boolean, String],
      default: "auto",
    },
    codigoIbge: {
      type: [String, Number],
      default: null,
    },
    filterByMunicipio: {
      type: Array,
      default: () => [],
    },
    municipiosPermitidos: {
      type: Array,
      default: () => [],
    },
    municipiosProps: {
      type: [Object, Array],
      default: () => ({}),
    },
  },
  mounted() {
    if (this.municipiosProps.length > 0) {
      this.municipios = this.municipiosProps;
      this.allMunicipios = this.municipiosProps;
    } else {
      this.loadCities();
    }
  },
  computed: {
    ...mapGetters(["isSala", "isParceiro", "isGov", "user"]),

    likesAll() {
      return this.filter.municipio.length === this.municipios.length;
    },
    likesSome() {
      return this.filter.municipio.length > 0 && !this.municipios;
    },
    icon() {
      if (this.likesAll) return "mdi-close-box";
      if (this.likesSome) return "mdi-minus-box";
      return "mdi-checkbox-blank-outline";
    },
    visualizaTodosMunicipios() {
      return this.user && this.user.visualizaMunicipio;
    },

    naoVerTodosMunicipios() {
      //   if (!this.visualizaTodosMunicipios) return true;
      return true;
    },
  },
  watch: {
    status: {
      handler(val, oldVal) {
        if (val.length > 0) {
          this.municipios = this.municipios.filter((item) =>
            val.some((v) => v.statusId === item.statusId)
          );
        } else {
          this.municipios = this.allMunicipios;
        }
      },
      deep: true,
    },
    codigoIbge: {
      handler(val) {
        this.buscarPorCodigoIbge(val);
      },
      immediate: true,
    },
    filterByMunicipio: {
      handler(val) {
        this.filtrarMunicipios(val);
      },
      immediate: true,
      deep: true,
    },
    allMunicipios: {
      handler(municipios) {
        if (municipios.length > 0 && this.codigoIbge) {
          this.buscarPorCodigoIbge(this.codigoIbge);
        }

        if (
          this.naoVerTodosMunicipios &&
          this.municipiosPermitidos.length > 0
        ) {
          this.municipios = this.municipios.filter((item) =>
            this.municipiosPermitidos.some(
              (v) => v.municipioId === item.municipioId
            )
          );
        }

        if (municipios.length > 0 && this.filterByMunicipio) {
          this.filtrarMunicipios();
        }
      },
      immediate: true,
    },
    municipiosPermitidos: {
      handler(val) {
        if (this.naoVerTodosMunicipios && this.municipios.length > 0) {
          this.municipios = this.municipios.filter((item) =>
            val.some((v) => v.municipioId === item.municipioId)
          );
        }
      },
      immediate: true,
    },
    municipiosProps: {
      handler(val) {
        if (!Array.isArray(val) || val.length === 0) return;

        this.allMunicipios = val;
        this.municipios = val;
        if (this.naoVerTodosMunicipios && this.municipiosPermitidos.length > 0) {
          this.municipios = this.municipios.filter((item) =>
            this.municipiosPermitidos.some(
              (permitido) => permitido.municipioId === item.municipioId
            )
          );
        }
        this.filtrarMunicipios();
        this.$emit("allMunicipio", this.allMunicipios);
      },
      deep: true,
    },
  },
  methods: {
    loadCities() {
      cityAPI
        .listNames()
        .then((resp) => {
          this.municipios = resp.data;
          this.allMunicipios = resp.data;
          this.$emit("allMunicipio", this.allMunicipios);
        })
        .catch();
    },
    filtrarMunicipios() {
      if (
        this.filterByMunicipio &&
        this.filterByMunicipio.length > 0 &&
        this.allMunicipios.length > 0
      ) {
        this.municipios = this.municipios.filter((item) =>
          this.filterByMunicipio.some((v) => v.codigoIBGE === item.codigoIBGE)
        );
      }
    },
    buscarPorCodigoIbge(codigoIbge) {
      if (codigoIbge && this.allMunicipios.length > 0) {
        const municipioEncontrado = this.municipios.find(
          (item) => item.codigoIBGE === codigoIbge
        );

        if (municipioEncontrado) {
          if (this.isMultiple) {
            if (
              !this.filter.municipio.some((m) => m.codigoIBGE === codigoIbge)
            ) {
              this.filter.municipio.push(municipioEncontrado);
            }
          } else {
            this.filter.municipio = municipioEncontrado;
          }

          this.$emit("changeCity", this.filter.municipio);
        } else {
          console.warn(
            "Município não encontrado para código IBGE:",
            codigoIbge
          );
        }
      }
    },

    toggle() {
      this.$nextTick(() => {
        if (this.likesAll) {
          this.filter.municipio = [];
          this.$emit("changeCity", this.filter.municipio);
        } else {
          this.filter.municipio = this.municipios.slice();
          this.$emit("changeCity", this.filter.municipio);
        }
      });
    },
  },

  data() {
    return {
      maxDisplay: 2,
      municipios: [],
      allMunicipios: [],
    };
  },
};
</script>
